import React from 'react'
import useCourseEnrollability from '../../user/hooks/use-user-course-enrollability'

const EnrollabilityLabel = ({
    experience = {}
}) => {
    const { reason } = useCourseEnrollability({ courseId: experience.id })
    if (!reason) {
        return null
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                color: 'red',
                paddingTop: '10px'
            }}
            className='text-center'
        >
            <small>{reason}</small>
        </div>
    )
}

export default EnrollabilityLabel
